import React from 'react';
import './Placeholder.css';

export function Placeholder() {
  return (
    <section className="page-shell placeholder-page">
      <div className="placeholder-content">
        <h1 className="placeholder-heading">Coming soon</h1>
        <p className="placeholder-subheading">
          This page is currently under construction. Please check back later.
        </p>
      </div>
    </section>
  );
}
